import React, { useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Modal from "react-modal";
import { BiCheckIcon, BiXIcon } from "../../images/icons/icons";

function DateRanger({
  handleDateRangeChange,
  rangeState,
  closeRanger,
  onClose,
  onClear,
  isDisableFutureDates,
}) {
  const dateRangeRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        closeRanger &&
        dateRangeRef.current &&
        !dateRangeRef.current.contains(event.target)
      ) {
        closeRanger();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dateRangeRef, handleDateRangeChange]);

  return (
    <Modal
      isOpen={true}
      onRequestClose={closeRanger}
      contentLabel="Detail Modal"
      ariaHideApp={false}
    >
      <div className="createNewCTOModalContainer date-ranger-common-modal">
        <div ref={dateRangeRef} className="react-date-range-container">
          <DateRangePicker
            onChange={(item) => handleDateRangeChange(item)}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={rangeState}
            direction="horizontal"
            maxDate={isDisableFutureDates ? new Date() : undefined}
          />

          <div className="close-clear-btns">
            <button
              onClick={onClose}
              type="button"
              className="closeClearBtn close-btn"
            >
              <BiCheckIcon /> Close
            </button>
            <button
              onClick={() => {
                onClear();
                onClose();
              }}
              type="button"
              className="closeClearBtn clear-btn"
            >
              <BiXIcon /> Clear
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DateRanger;
